import add from "./addUserAccess";
import edit from "./editUserAccess";
import remove from "./removeUserAccess";

export default {
  add,
  edit,
  remove,
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/access/index.js